import React from "react";
import DateField from "./fields/DateField";
import FileUploadField from "./fields/FileUploadField";
import RadioField from "./fields/RadioField";
import SelectField from "./fields/SelectField";
import TextareaField from "./fields/TextareaField";
import TextField from "./fields/TextField";
import TimeField from "./fields/TimeField";
import {
  getDescriptionPlaceholder,
  isComponentRequired,
  isComponentVisible,
} from "../utils/componentListRules";

export default function DynamicFieldRenderer(props) {
  const {
    field,
    componentList,
    componentErrors,
    onFieldChange,
    labels,
    filesByFieldId,
    allowedExtensions,
    fileSizeLimit,
    limitOfFileNumber,
    onUploadSuccess,
    onRemoveSuccess,
    uploading,
  } = props;

  if (!isComponentVisible(field, componentList)) {
    return null;
  }

  const required = isComponentRequired(field, componentList);
  const error = Boolean(componentErrors[field.id]);
  const errorType = componentErrors[field.id] || "";
  const placeholder = getDescriptionPlaceholder(field, labels, componentList);

  if (field.type === "text" || field.type === "email") {
    return (
      <TextField
        field={field}
        required={required}
        error={error}
        errorType={errorType}
        placeholder={placeholder}
        onChange={onFieldChange}
      />
    );
  }

  if (field.type === "textarea") {
    return (
      <TextareaField
        field={field}
        required={required}
        error={error}
        errorType={errorType}
        placeholder={placeholder}
        onChange={onFieldChange}
      />
    );
  }

  if (field.type === "radio") {
    return (
      <RadioField
        field={field}
        required={required}
        error={error}
        onChange={onFieldChange}
      />
    );
  }

  if (field.type === "dropdown") {
    return (
      <SelectField
        field={field}
        required={required}
        error={error}
        placeholder={placeholder}
        onChange={onFieldChange}
      />
    );
  }

  if (field.type === "date") {
    return (
      <DateField
        field={field}
        required={required}
        error={error}
        placeholder={placeholder}
        onChange={onFieldChange}
      />
    );
  }

  if (field.type === "time") {
    return (
      <TimeField
        field={field}
        required={required}
        error={error}
        placeholder={placeholder}
        onChange={onFieldChange}
      />
    );
  }

  if (field.type === "file_upload") {
    return (
      <FileUploadField
        field={field}
        required={required}
        error={error}
        files={filesByFieldId[field.id] || []}
        allowedExtensions={allowedExtensions}
        fileSizeLimit={fileSizeLimit}
        limitOfFileNumber={limitOfFileNumber}
        onUploadSuccess={onUploadSuccess}
        onRemoveSuccess={onRemoveSuccess}
        disabled={uploading}
      />
    );
  }

  return null;
}
